import _ from "underscore";
import {
  PlayerResultInfo,
  Results,
  ScoredSwap,
} from "../../shared/interfaces/GameLogicTypes";

//Was brauche
export function interpretResultsForPlayer(
  results: Results,
  tsarId: string,
  playerId: string
) {
  if (!("playerTurnResults" in results[tsarId])) {
    return {
      tsarAnswered: false,
      iAnswered: false,
      tsarResults: results[tsarId],
      myResults: results[playerId],
    };
  } else if (!("playerTurnResults" in results[playerId])) {
    return {
      tsarAnswered: true,
      iAnswered: false,
      tsarResults: results[tsarId],
      myResults: results[playerId],
    };
  } else {
    return {
      tsarAnswered: true,
      iAnswered: true,
      tsarResults: results[tsarId],
      myResults: results[playerId],
    };
  }
}
export function interpretResultsForTsar(results: Results, tsarId: string) {
  if (!("playerTurnResults" in results[tsarId])) {
    //sorry
    return { tsarAnswered: false, tsarResults: null };
  } else {
    return { tsarAnswered: true, tsarResults: results[tsarId] };
  }
  // return {tsaranswered: "", onePlayerAnswer:"", multiPlayerAnswer:"", playerResult:"", tsarsequence: "", bestPlayerSequence:"" };
}

export function hasPlayerAnswered(results: Results, playerId: string) {
  if (
    results[playerId] == undefined ||
    JSON.stringify(results[playerId].playerTurnResults.sequence) ==
      JSON.stringify([0, 0, 0, 0, 0])
  ) {
    return false;
  } else {
    return true;
  }
}

export function getPlayerResults(results: Results, playerId: string) {
  // console.log("entered getPlayerResults :)");
  // console.log("trying to getPlayerSequence from results. Calling getPlayersequence using results: " + JSON.stringify(results,null,2));
  if (playerId in results && "playerTurnResults" in results[playerId]) {
  
    const playerResults = results[playerId];
    if (playerResults.playerTurnResults != undefined) {
      return playerResults.playerTurnResults;
    } else {
      console.log("returned undefined playerTurnResults in getPResults with results " + JSON.stringify(results,null,2) + "\n pId" + playerId);
      return undefined;
    }
  }
}
export function getPlayerScore(results: Results, playerId: string) {
  const playerResults = getPlayerResults(results, playerId);
  if (playerResults != undefined) {
    return playerResults["points"];
  } else {
    return 0;
  }
}

export function getPlayerName(results: Results, playerId: string) {
  if (playerId in results) {
    return results[playerId].playerInfo.name;
  } else {
    return "";
  }
}

export function getPlayerSequence(results: Results, playerId: string) {
  //console.log("trying to getPlayerSequence from results. Calling getPlayerResults using results: " + JSON.stringify(results,null,2));
  const playerResults = getPlayerResults(results, playerId);
  if (playerResults != undefined) {
    return playerResults.sequence;
  } else {
    //console.log("cant get playe sequence because results undefined");
    return [0, 0, 0, 0, 0];
  }
}

export function getPlayerSwaps(results: Results, playerId: string) {
  const playerResults = getPlayerResults(results, playerId);
  if (playerResults != undefined) {
    return playerResults["swaps"];
  } else {
    return [];
  }
}

export function applyScoredSwap(sequence: number[], scoredSwap: ScoredSwap) {
  let swapIndices = scoredSwap.swap;
  let temp = sequence[swapIndices[0]];
  sequence[swapIndices[0]] = sequence[swapIndices[1]];
  sequence[swapIndices[1]] = temp;
  return sequence;
}

export type GroupPredictionTier = 'perfect' | 'great' | 'good' | 'average' | 'bad' | 'terrible';

export interface CzarGroupSummary {
  avgScore: number;
  tier: GroupPredictionTier;
  answeredCount: number;
}

export function getCzarGroupSummary(
  sortedNonTsarResults: { score: number }[]
): CzarGroupSummary {
  const answered = sortedNonTsarResults.filter(
    (r) => !(r.score === 0)
  );
  if (answered.length === 0) {
    return { avgScore: 0, tier: 'terrible', answeredCount: 0 };
  }
  const avgScore = Math.round(
    answered.reduce((sum, r) => sum + r.score, 0) / answered.length
  );
  let tier: GroupPredictionTier;
  if (answered.every((r) => r.score === 2000)) tier = 'perfect';
  else if (avgScore >= 1600) tier = 'great';
  else if (avgScore >= 1200) tier = 'good';
  else if (avgScore >= 800) tier = 'average';
  else if (avgScore >= 400) tier = 'bad';
  else tier = 'terrible';
  return { avgScore, tier, answeredCount: answered.length };
}

export function getPlayerSubmissionResultList(
  results: Results,
  tsarId: string
) {
  //Goal get a list of the Playerresults of the form [name,sequence,score] with [0,0,0,0,0] for players that did not submit
  const playerSubmissionResultList = Object.keys(results).map(
    (playerId: string) => {
      //if (playerId != tsarId) {
      const playerName = getPlayerName(results, playerId);
      if (!hasPlayerAnswered(results, playerId)) {
        console.log("player has not answered " + playerId);
        return {
          playerId: playerId,
          playerName: playerName,
          sequence: [0, 0, 0, 0, 0],
          score: 0,
        };
      } else {
        return {
          playerId: playerId,
          playerName: playerName,
          sequence: getPlayerSequence(results, playerId),
          score: getPlayerScore(results, playerId),
        };
      }
      //}
    }
  );
  // In versus there is no reference player to exclude (tsarId is ""); indexOf would return -1 and
  // splice(-1, 1) would silently drop the LAST player from the list.
  const tsarIndex = playerSubmissionResultList.findIndex(
    (entry) => entry["playerId"] == tsarId
  );
  if (tsarIndex >= 0) {
    playerSubmissionResultList.splice(tsarIndex, 1);
  }
  playerSubmissionResultList.sort((a, b) => b["score"] - a["score"]);
  console.log("after mapping " + JSON.stringify(playerSubmissionResultList));
  return playerSubmissionResultList;
}
